import React, { FC } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { Member } from '../../@types/member'
import { Prefix } from '../../@types/prefix'
import { makePath } from '../../helpers/path'
import { Avatar, Button } from 'antd';

interface TopbarProps {
	prefix?: Prefix
	member?: Member

	pathname: string
}
const Topbar: FC<TopbarProps> = ({ prefix, member, pathname }) => {
	const history = useHistory()

	return (
		<>
			<div className='topbar'>
				<div className="topbar-logo">
					<Link to={makePath('/home')}>
						{prefix?.logo ? (
							<Avatar
								className="avatar-logo avatar-logo-topbar"
								src={prefix?.logo}
								shape="square"
							/>
						) : (
							<div className="prefix-name">{prefix?.prefix}</div>
						)}
					</Link>
				</div>

				{/* <div className="pg-verify">
					<img src="/pg-verify.gif" alt="pg-verify" />
					<div className="pg-verify-text">
						<div><small>verified by</small></div>
						<div>PGSOFT</div>
					</div>
				</div> */}

				<div className="topbar-member">
					<Button
						type='primary'
						size='small'
						style={{ display: 'block', fontSize: 14 }}
						onClick={() => history.push(makePath('/login'))}
					>
						เข้าสู่ระบบ
					</Button>
					{(!prefix?.functions.hasOwnProperty("offRegister") || !prefix?.functions['offRegister']) && (
						<Button
							size='small'
							style={{ marginLeft: 12, display: 'block', fontSize: 14 }}
							onClick={() => history.push(makePath('/register'))}
						>
							สมัครสมาชิก
						</Button>
					)}
				</div>
			</div>
		</>
	)
}

export default Topbar

